import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Menu from '../menu';
import { Button, DatePicker, Icon, Input, Pagination, Select, Table } from '../../components';
import { axios, Colors, Globals } from '../../utils';

const STATUS = {
  PENDING: 0,
  DELIVERED: 1,
};

const statusList = [
  { value: STATUS.PENDING, label: 'Por entregar' },
  { value: STATUS.DELIVERED, label: 'Entregado' },
];

class DispatchRoutes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      header: [
        "N° de pedido",
        "Cliente",
        "Monto",
        "Ruta asignada",
        "Fecha de despacho",
        "Estatus",
        "Observaciones",
        "Acciones"
      ],
      form: {
        id: '',
        search: '',
        client_id: null,
        since: "",
        until: "",
        status: null,
        admin_id: this.props.user.admin_id != null ? this.props.user.admin_id : this.props.user.id,
        user_id: this.props.user.id,
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
      page: 1,
      last_page: 1,
      data: [],
      clients: [],
    };
  }

  abortController = new AbortController()

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort()
  }

  load = (page = 1) => {
    // Globals.setLoading();
    // let param = this.state.form;
    // param.user_id = this.props.user.id;
    // axios
    //   .post("web/admin/quotes?page=" + this.state.page, param)
    //   .then(res => {
    //     if (res.data.quotes) {
    //       this.setState({
    //         page,
    //         last_page: res.data.quotes.last_page,
    //         data: res.data.quotes.data,
    //         methods: res.data?.payment_methods,
    //         id_selected: []
    //       });
    //     }
    //   })
    //   .catch(err => {
    //     Globals.showError();
    //   })
    //   .then(() => {
    //     Globals.quitLoading();
    //   });

    this.setState({ data: [
      {
        id: 1,
        number_format: "3700",
        client: {
          name: "Distribuidora Burguer",
        },
        total: 95,
        route: 'Ruta 50',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 2,
        number_format: "3699",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 1100,
        route: 'Ruta 100',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 3,
        number_format: "3698",
        client: {
          name: "Comercial 88 C.A",
        },
        total: 195,
        route: 'Ruta este 50',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 4,
        number_format: "3697",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 125,
        route: 'Ruta norte 100',
        date: '2025-03-10',
        status: STATUS.DELIVERED,
        observations: '',
      },
      {
        id: 5,
        number_format: "3696",
        client: {
          name: "Distribuidora Burguer",
        },
        total: 95,
        route: 'Ruta 41',
        date: '2025-03-05',
        status: STATUS.DELIVERED,
        observations: '',
      },
      {
        id: 6,
        number_format: "3695",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 1100,
        route: 'Ruta norte 50',
        date: '2025-03-05',
        status: STATUS.DELIVERED,
        observations: '',
      },
    ] })
  };

  getStatus = (status) => {
    switch (status) {
      case STATUS.PENDING:
        return {
          text: "Por entregar",
          color: Colors.red,
        };

      case STATUS.DELIVERED:
        return {
          text: "Entregado",
          color: Colors.black,
        };

      default:
        return {
          text: "No definido",
          color: Colors.black,
        };
    }
  };

  deliver = (route_id) => {
    Globals.confirm("¿Seguro de marcar como entregado?", () => {
      // Globals.setLoading("Guardando...");
      // axios
      //   .post(`admin/quotes/delete`, { route_id })
      //   .then(res => {
      //     Globals.showSuccess('Cotización eliminado');
      //     this.load();
      //   })
      //   .catch(err => {
      //     Globals.showError(err.response.data.msg);
      //   })
      //   .then(() => {
      //     Globals.quitLoading();
      //   });
    });
  };

  delete = (route_id) => {
    Globals.confirm("¿Seguro de eliminar la ruta de despacho?", () => {
      // Globals.setLoading("Guardando...");
      // axios
      //   .post(`admin/quotes/delete`, { route_id })
      //   .then(res => {
      //     Globals.showSuccess('Cotización eliminado');
      //     this.load();
      //   })
      //   .catch(err => {
      //     Globals.showError(err.response.data.msg);
      //   })
      //   .then(() => {
      //     Globals.quitLoading();
      //   });
    });
  };

  handleChange = (value, target) => {
    this.setState(s => ({
      form: { ...s.form, [target]: value }
    }));
  };

  render() {
    const { history } = this.props;
    const { data, form, header } = this.state;

    return (
      <Menu history={history}>
        <div id="dispatch-routes">
          <div className="row">
            <div className="col-md-2">
              <Input
                color=" "
                name="search"
                label="Buscar"
                className="filter"
                onChange={e => this.handleChange(e.target.value, 'search')}
                value={form.search}
                placeholder="ID o nombre de la ruta"
              />
            </div>
            <div className="col-md-2">
              <Input
                color=" "
                name="search"
                label="N° de pedido"
                className="filter"
                onChange={e => this.handleChange(e.target.value, 'id')}
                value={form.id}
                placeholder="Todos"
              />
            </div>
            <div className="col-md-2">
              <Select
                color="white"
                name="client_id"
                label="Clientes"
                className="filter"
                defaultname="Seleccione"
                onChange={e => this.handleChange(e.target.value, 'client_id')}
                value={form.client_id}
                options={this.state.clients}
              />
            </div>
            <div className="col-md-2">
              <Select
                color="white"
                name="status"
                label="Estatus"
                className="filter"
                defaultname="Seleccione"
                onChange={e => this.handleChange(e.target.value, 'status')}
                value={form.status}
                options={statusList}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={form.since}
                onChange={v => this.handleChange(v, 'since')}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={form.until}
                onChange={v => this.handleChange(v, 'until')}
              />
            </div>
            <div className="col-md-3" style={{ display: 'flex', gap: '1rem' }}>
              <Button
                className="btn-align-bottom btn-filter"
                color=" "
                style={{ minWidth: 110 }}
                onClick={async () => {
                  await this.setState({ page: 1 });
                  this.load();
                }}
              >
                <span>Filtrar</span>
              </Button>
              <Button
                className="btn-align-bottom btn-filter"
                color=" "
                style={{ minWidth: 110 }}
                onClick={this.returnState}
              >
                <span>Limpiar</span>
              </Button>
            </div>
          </div>

          <Table
            title=""
            header={header}
            data={data.length}
            right={
              <button
                style={{ padding: 0, border: 'none' }}
                onClick={() => this.props.history.push('/dispatch-routes/create')}
              >
                <div style={{ background: '#3A7FC2', color: '#fff', fontSize: '16px', padding: '8px 16px', borderRadius: '5px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span>Asignar pedidos a ruta de despacho</span>
                  <Icon name="plus" />
                </div>
              </button>
            }
          >
            {data.map((Item, index) => {
              const status = this.getStatus(Item.status);
              return (
                <tr key={index}>
                  <td>{Item.number_format}</td>
                  <td>{Item.client?.name ?? 'No tiene'}</td>
                  <td>{Globals.formatMiles(Item.total)}</td>
                  <td>{Item.route ?? 'No tiene'}</td>
                  <td>{moment(Item.date).format('DD-MM-YYYY')}</td>
                  <td>
                    <span style={{ color: status.color }}>{status.text}</span>
                  </td>
                  <td>{Item.observations || '--'}</td>
                  <td>
                    {Item.status === STATUS.PENDING && (
                      <Button
                        color="green"
                        title="Entregado"
                        small="true"
                        onClick={() => this.deliver(Item.id)}
                      >
                        <span>Entregado</span>
                      </Button>
                    )}
                    <Button
                      title="Editar"
                      small="true"
                      color=" "
                      style={{ backgroundColor: '#0f54e0' }}
                      onClick={() => this.props.history.push(`/dispatch-routes/${Item.id}/edit`)}
                    >
                      <Icon name="edit" />
                    </Button>
                    <Button
                      color="red"
                      title="Eliminar"
                      small="true"
                      onClick={() => this.delete(Item.id)}
                    >
                      <Icon name="trash" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => this.load(page)}
          />
        </div>
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(DispatchRoutes);
